import React, { useState } from 'react';

// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import styled from '@emotion/styled';

import { Text } from '@atlaskit/primitives/compiled/text';
import Toggle from '@atlaskit/toggle/toggle';
import { token } from '@atlaskit/tokens';

interface ErrorSectionProps {
	errorDetails: string;
}

export const ErrorSection: React.FC<ErrorSectionProps> = ({ errorDetails }) => {
	const [showErrorDetails, setShowErrorDetails] = useState<boolean>(false);

	return (
		<div>
			<ErrorSectionLabel>
				{/* eslint-disable-next-line @atlassian/i18n/no-literal-string-in-jsx */}
				<Text as="p">Show error details:</Text>
				<Toggle
					isChecked={showErrorDetails}
					onChange={() => {
						setShowErrorDetails(!showErrorDetails);
					}}
				/>
			</ErrorSectionLabel>
			{showErrorDetails && (
				<ErrorDetailsWrapper>
					{/* eslint-disable-next-line @atlaskit/design-system/no-html-code */}
					<code>{errorDetails}</code>
				</ErrorDetailsWrapper>
			)}
		</div>
	);
};

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const ErrorSectionLabel = styled.div({
	display: 'flex',
	marginTop: token('space.250'),
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
	'> p': {
		marginTop: token('space.025'),
	},
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const ErrorDetailsWrapper = styled.div({
	backgroundColor: token('color.background.neutral'),
	padding: token('space.100'),
	font: token('font.body.small'),
});
